export const SET_USERS_LIST = 'users/SET_USERS_LIST'
export const SET_MANAGE_USER = 'users/SET_MANAGE_USER'
export const UPDATE_USER = 'users/UPDATE_USER'
export const SET_USER_SESSIONS_LIST = 'users/SET_USER_SESSIONS_LIST'
export const SET_USER_LOGINS_LIST = 'users/SET_USER_LOGINS_LIST'
export const SET_USER_EMAIL_LOGS_LIST = 'users/SET_USER_EMAIL_LOGS_LIST'
export const SET_USER_LEARNING_PATH_LIST = 'users/SET_USER_LEARNING_PATH_LIST'
export const SET_USER_CANCELED_LIST = 'users/SET_USER_CANCELED_LIST'
export const SET_USER_PROGRAMS_LIST = 'users/SET_USER_PROGRAMS_LIST'
